import React, { ReactNode } from 'react';
import EVerifyUser from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUser';
import { columns } from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUsersTableData';
import AlertConstants from '../../../../constants/AlertConstants';
import BaseEVerifyUsers from './BaseEVerifyUsers';

const ClientEverifyUsers = (): JSX.Element => {
  const primaryText: ReactNode = (
    <div className="tablet:grid-col-12 desktop:grid-col-9">
      <p className="usa-intro">Add one client contact as the Signatory.</p>
    </div>
  );

  const secondaryText =
    'This person must have authority to sign the Terms and Conditions on behalf of your client company. After you submit the enrollment the Signatory will need to sign the Memorandum of Understanding (MOU).';

  const clientColumns = columns.filter(({ accessor }) => !['mouSignatory', 'admin'].includes(accessor as string));

  const isAddDisabled = (users: EVerifyUser[]) => users.length === 1;

  const checkUsersForError = (users: EVerifyUser[]): AlertConstants | undefined => {
    if (users?.length === 0) {
      return AlertConstants.EVERIFY_USERS_NO_MOU_SIGNATORY;
    }
    return undefined;
  };

  return (
    <BaseEVerifyUsers
      addButtonText="Add Signatory"
      noRowsText="No Signatory Added"
      pageTitle="Signatory"
      primaryText={primaryText}
      secondaryText={secondaryText}
      columns={clientColumns}
      isAddDisabled={isAddDisabled}
      checkUsersForError={checkUsersForError}
    />
  );
};

export default ClientEverifyUsers;
